//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../../library/umum'
import FETCHING from  '../../../../library/fetching'
import uniqid from 'uniqid';

export default {
  data() {
    return {

        form : {
            id : '',
            nama : '',
            jabatan : '',
            tpt_lahir : '',
            tgl_lahir : '',
            pendidikan : '',
            agama : '',
            penandatangan : true,
            masterJenisPamong : '',
            masterJenisPamongJabatan : '',

            masterJenisPamong_uraian : '',
            masterJenisPamongJabatan_uraian : '',
            createdAt : '',
            createdBy : '',
            file : null,
            des_kel : '',
        },
        uraian : {
          agama_uraian : '',
          pendidikan_uraian : ''
        },

        fileOld : '',




        list_data : [],
        list_pendidikan : [],
        list_agama : [],
        list_JenisPamong : [],
        list_JenisPamongJabatan : [],
        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,


        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_lihat: false,
        mdl_lihat_file: false,
        btn_add: false,


        mdl_pendidikanNonFormal : false,
        mdl_pendidikanFormal : false,
        mdl_keluarga : false,
        mdl_prestasi : false,
        mdl_jabatan_perangkat : false,


        loadJabatan : false,

        UMUM : UMUM,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_ADM_DESA_PEGAWAI + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    addData : function(number) {

        // console.log(this.form)
        var formData = new FormData();

        formData.append("id", uniqid());
        formData.append("nama", this.form.nama);
        formData.append("jabatan", this.form.jabatan);
        formData.append("tpt_lahir", this.form.tpt_lahir);
        formData.append("tgl_lahir", this.form.tgl_lahir);
        formData.append("pendidikan", this.form.pendidikan);
        formData.append("des_kel", this.form.des_kel);
        formData.append("agama", this.form.agama);
        formData.append("masterJenisPamongJabatan", this.form.masterJenisPamongJabatan);
        formData.append("penandatangan", this.form.penandatangan);
        formData.append("createdAt", UMUM.NOW());
        formData.append("file", this.form.file);


        // console.log(this.form);


        fetch(this.$store.state.url.URL_ADM_DESA_PEGAWAI + "addData", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData : function(){

      var formData = new FormData();

        formData.append("id", this.form.id);
        formData.append("nama", this.form.nama);
        formData.append("jabatan", this.form.jabatan);
        formData.append("tpt_lahir", this.form.tpt_lahir);
        formData.append("tgl_lahir", this.form.tgl_lahir);
        formData.append("pendidikan", this.form.pendidikan);
        formData.append("agama", this.form.agama);
        formData.append("masterJenisPamongJabatan", this.form.masterJenisPamongJabatan);
        formData.append("penandatangan", this.form.penandatangan);
        formData.append("createdAt", this.form.createdAt);
        formData.append("file", this.form.file);

        formData.append("fileOld", this.fileOld);


      fetch(this.$store.state.url.URL_ADM_DESA_PEGAWAI + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_ADM_DESA_PEGAWAI + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id : this.form.id,
              fileOld : this.fileOld,

          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : async function(data){

            this.loadJabatan = false;

            this.form.id = data.id;
            this.form.nama= data.nama;
            this.form.jabatan= data.jabatan;
            this.form.tpt_lahir= data.tpt_lahir;
            this.form.tgl_lahir= data.tgl_lahir;
            this.form.pendidikan= data.pendidikan;
            this.form.agama= data.agama;
            this.form.penandatangan = data.penandatangan;
            this.form.createdAt = data.createdAt;
            this.form.createdBy = data.createdBy;
            this.form.des_kel = data.des_kel;
            this.form.masterJenisPamongJabatan = data.masterJenisPamongJabatan;
            // this.form.file = data.file;

            this.form.masterJenisPamong_uraian = data.masterJenisPamong_uraian;
            this.form.masterJenisPamongJabatan_uraian = data.masterJenisPamongJabatan_uraian;

            this.uraian.agama_uraian = data.agama_uraian
            this.uraian.pendidikan_uraian = data.pendidikan_uraian

            this.fileOld = data.file;


            const body = {id : data.masterJenisPamongJabatan, uraian : ''}
            this.list_JenisPamongJabatan = await FETCHING.FETCH_POST(this.$store.state.url.URL_DATAMASTER_JENIS_PAMONG_JABATAN+'list', body)
            // console.log(data.file)
            this.loadJabatan = true;

            // console.log(data);

            // console.log(this.form)
    },

    getList : async function(){
      this.list_pendidikan = await FETCHING.FETCH_GET(this.$store.state.url.URL_DATAMASTER_PENDIDIKAN);
      this.list_agama = await FETCHING.FETCH_GET(this.$store.state.url.URL_DATAMASTER_AGAMA)
      // this.list_JenisPamong = await FETCHING.FETCH_GET(this.$store.state.url.URL_DATAMASTER_JENIS_PAMONG)

      const body = {uraian : ''}
      this.list_JenisPamongJabatan = await FETCHING.FETCH_POST(this.$store.state.url.URL_DATAMASTER_JENIS_PAMONG_JABATAN+'list', body)

    },

    postList : function (val, update, abort) {
      update(async () => {
          if (val === '') {}
          else {
            const body = {uraian : val}
            this.list_JenisPamongJabatan = await FETCHING.FETCH_POST(this.$store.state.url.URL_DATAMASTER_JENIS_PAMONG_JABATAN+'list', body)
          }
        })
    },

    emptytData : function(data){



    },


    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
            
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },

        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        },




    // ====================================== PAGINATE ====================================







  },

  mounted () {
        // new FroalaEditor('textarea#froala-editor')

      var profilex = JSON.parse(localStorage.profile)
      var profile = profilex.profile
      this.$store.state.ID_DES_KEL = profile.des_kel


      this.form.des_kel = profile.des_kel


        this.getList();
        // this.postList('');
        this.getView();
  },
}
